import { getHotkeyMenu, HOTKEY_TYPE, useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = ({ activeLayer }: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();

    if (!activeLayer) return null;

    const disabled = !framework.checkIsFormalGroup(activeLayer);
    const notBrokenGroup = !framework.checkBrokenGroup(activeLayer);

    const item = {
        disabled: disabled || notBrokenGroup,
        name: $t((v) => v.contextMenuLayer.menuConfig.brokeGroup),
        type: HOTKEY_TYPE.brokeGroup,
        desc: getHotkeyMenu(HOTKEY_TYPE.brokeGroup),
        onClick: () => {
            framework.events.emit(HOTKEY_TYPE.brokeGroup);
        },
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 2,
    sort: 2,
    render,
} as IExportContextMenuItem;
